import type { Actor } from "../models/Actor";

export const ACTOR_AVATAR_PALETTE: string[] = [
  "bg-creator-primary text-white",
  "bg-creator-secondary text-white",
  "bg-creator-error text-white",
  "bg-interaction-secondary text-white",
  "bg-interaction-correct text-white",
  "bg-creator-text-soft text-white",
  "bg-interaction-primary text-white",
  "bg-interaction-false text-white",
];

function hashString(seed: string): number {
  let hash = 0;
  for (let index = 0; index < seed.length; index += 1) {
    hash = (hash * 31 + seed.charCodeAt(index)) >>> 0;
  }
  return hash;
}

function normalizeAvatarColorIndex(index: number): number {
  if (!Number.isFinite(index)) return 0;
  return (
    ((Math.trunc(index) % ACTOR_AVATAR_PALETTE.length) +
      ACTOR_AVATAR_PALETTE.length) %
    ACTOR_AVATAR_PALETTE.length
  );
}

export function getActorAvatarColorByIndex(index: number): string {
  return ACTOR_AVATAR_PALETTE[normalizeAvatarColorIndex(index)];
}

export function getActorAvatarColorIndex(
  actor: Pick<Actor, "id" | "profilePicture"> | undefined
): number {
  if (!actor) return 0;
  if (typeof actor.profilePicture === "number" && actor.profilePicture >= 0) {
    return normalizeAvatarColorIndex(actor.profilePicture);
  }
  return hashString(actor.id ?? "") % ACTOR_AVATAR_PALETTE.length;
}

export function getActorAvatarColor(
  actor: Pick<Actor, "id" | "profilePicture"> | undefined
): string {
  return ACTOR_AVATAR_PALETTE[getActorAvatarColorIndex(actor)];
}

export function getActorAvatarInitial(workingName: string | undefined): string {
  const trimmed = (workingName ?? "").trim();
  return (trimmed[0] ?? "?").toUpperCase();
}
